import type { SxProps, Theme } from "@mui/material/styles";

export const root: SxProps<Theme> = (theme) => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 1.25,
  bgcolor: "background.paper",
  border: `1.5px solid ${theme.palette.divider}`,
  borderRadius: 1.5,
  py: 1.5,
  px: 1.5,
  fontFamily: theme.typography.fontFamily,
  fontSize: "0.875rem",
  fontWeight: 600,
  color: "text.primary",
  cursor: "pointer",
  textDecoration: "none",
  transition: "all 0.2s ease",
  "&:hover": {
    bgcolor: "action.hover",
  },
});

export const iconWrap: SxProps<Theme> = {
  display: "inline-flex",
  alignItems: "center",
  color: "primary.main",
};
